import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  Spinner,
  Image,
  Loading,
  Button,
  DataTable,
  ButtonGroup,
  Toast,
  Checkbox,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  Link,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Pagination from "@mui/material/Pagination";
import EllipsisText from "react-ellipsis-text";
import moment from "moment";
import feel22Logo from "../../Assets/Images/feel22.png";
import myHoldalLogo from "../../Assets/Images/myHoldal.png";
import { SendIcon } from "@shopify/polaris-icons";
const SortingCenter = () => {
  const navigate = useNavigate();
  const addEditState = useRef("");
  const perPage = 100;
  const [ts, setTs] = useState("");
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [pageObject, setPageObject] = useState({
    isLoading: true,
    isSaving: false,
    tableItems: [],
    tableTotalPages: 0,
    isListEmpty: false,
  });

  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    {
      key: "availability",
      label: "Filter by",
      filter: (
        <ChoiceList
          title="Filter by"
          titleHidden
          choices={[
            { label: "Supplier Name", value: "supplier_name" },
            { label: "Client ID", value: "client_id" },
            { label: "EAN", value: "ean" },
            { label: "Phone Number", value: "client_phone" },
          ]}
          selected={availability || []}
          onChange={handleAvailabilityChange}
        />
      ),
      shortcut: false,
    },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }
  const loadingMarkup = pageObject.isLoading ? <Loading /> : null;
  const emtyState = pageObject.isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <Image src={emptyListImage}></Image>
      </div>
      <div className="mb-3">
        <Text variant="bodyLg" as="p">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    pageObject.isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const refBoolPage = useRef(true);
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  const handleEdit = (id) => {
    navigate(`/admin/homepage/banner/${id}`);
  };

  useEffect(() => {
    fetchData();
  }, [ts, availability, queryValue, page]);
  const [rowIds, setRowIds] = useState([]);

  async function fetchData() {
    let response = "";

    try {
      response = await axios.get(
        `/sorting-center?per_page=${perPage}&page=${
          refBoolPage.current ? page : 1
        }${
          queryValue
            ? `&filter[${
                availability === "" ? "ean" : availability
              }]=${queryValue}`
            : ""
        }`,
      );
      console.log(response.data.data);
      setPageObject({
        ...pageObject,
        tableItems: response.data.data.map((item, index) => [
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.ean !== null ? <Link monochrome>{item.ean}</Link> : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.supplier_name ? item?.supplier_name : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.client ? (
              <div>
                {/* ID: {item?.client_id}
                <br /> */}
                {item?.client?.first_name +
                  (item?.client?.last_name && item?.client?.last_name !== "null"
                    ? " " + item.client.last_name
                    : "")}
              </div>
            ) : (
              "-"
            )}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.client && item?.client?.phone_number
              ? item?.client?.phone_number
              : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            City:{" "}
            {item?.client && item?.client?.city ? (
              <EllipsisText text={item?.client?.city} length={30} />
            ) : (
              "-"
            )}
            <br />
            Addres:{" "}
            {item?.client && item?.client?.full_address ? (
              <EllipsisText text={item?.client?.full_address} length={30} />
            ) : (
              "-"
            )}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.orderservices_description !== null
              ? item?.orderservices_description
              : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.status ? <Badge>{item?.status}</Badge> : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.updated_at
              ? moment(item.updated_at).format("YYYY-MM-DD HH:mm:ss")
              : "-"}
          </div>,
          // <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
          //   {item?.assigned_driver ? item?.assigned_driver : "-"}
          // </div>,
          // <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
          //   {item?.client && item?.client?.longitude
          //     ? item?.client?.longitude
          //     : "-"}
          // </div>,
          // <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
          //   {item?.client && item?.client?.latitude
          //     ? item?.client?.latitude
          //     : "-"}
          // </div>,
          // <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
          //   {item?.notes ? (
          //     <EllipsisText text={item?.notes} length={30} />
          //   ) : (
          //     "-"
          //   )}
          // </div>,
          <ButtonGroup>
            <Button
              variant="primary"
              tone="critical"
              onClick={() => {
                refId.current = item.id;
                setActiveCancel(true);
                setNoteValue("");
              }}
            >
              Cancel
            </Button>
          </ButtonGroup>,
        ]),
        isLoading: false,
        isListEmpty: !response.data.data.length ? true : false,
        tableTotalPages: response.data.total,
      });
      const ids = response.data.data.map((item) => item.id); // extract API IDs
      setRowIds(ids);
    } catch (error) {
      console.log(error);
    }

    // if (!featuresList.length)
    //   try {
    //     responseFeatures = await axios.get(`features`);
    //     setFeaturesList(
    //       responseFeatures.data.data.data.map((item, index) => {
    //         return {
    //           label: item.name,
    //           value: item.id,
    //         };
    //       })
    //     );
    //   } catch (error) {
    //     console.log(error);
    //   }
  }

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This banner has been successfully deleted",
  );

  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const handleClickRow = (id) => {
    window.open(`/admin/sorting-center/${id}`, "_blank");
  };
  const [selectedRows, setSelectedRows] = useState([]); // store selected IDs
  const handleSelectRow = (id, checked) => {
    if (checked) {
      setSelectedRows((prev) => [...prev, id]);
    } else {
      setSelectedRows((prev) => prev.filter((rowId) => rowId !== id));
    }
  };

  const [isSaving, setIsSaving] = useState(false);
  const [activeTransfer, setActiveTransfer] = useState(false);
  const handleChangeModalTransfer = useCallback((activeTransfer) => {
    setActiveTransfer(false);
    setIsSaving(false);
  }, []);
  const handleYesTransfer = () => {
    const form_data = new FormData();
    selectedRows.forEach((id) => {
      form_data.append("order_ids[]", id);
    });
    form_data.append("type", "warehouse_beirut");

    setIsSaving(true);
    axios
      .post(`/manual-update`, form_data)
      .then((result) => {
        setToastContent(
          selectedRows.length > 1
            ? `${selectedRows.length} items have been successfully transferred`
            : "This item has been successfully transferred",
        );
        toggleActive();
        setIsSaving(false);
        setActiveTransfer(false);
        setTs(+new Date());
        setSelectedRows([]); // clear after transfer
      })
      .catch((err) => console.log(err));
  };
  const refId = useRef(null);
  const [noteValue, setNoteValue] = useState("");
  const [noteError, setNoteError] = useState("");
  const handleChangeNote = (newValue) => {
    setNoteValue(newValue);
    setNoteError("");
  };
  const [activeCancel, setActiveCancel] = useState(false);
  const handleChangeModalCancel = useCallback((activeCancel) => {
    setActiveCancel(false);
    setIsSaving(false);
  }, []);
  const handleYesCancel = () => {
    if (!noteValue) {
      setNoteError("This field is required");
    } else {
      const form_data = new FormData();
      form_data.append("_method", "PATCH");
      form_data.append("cancellation_description", noteValue);
      setIsSaving(true);
      axios
        .post(`/sorting-center/${refId.current}`, form_data)
        .then((result) => {
          setToastContent("This order has been successfully cancelled");
          toggleActive();
          setIsSaving(false);
          setActiveCancel(!activeCancel);
          setTs(+new Date());
        })
        .catch((err) => console.log(err));
    }
  };
  return (
    <Page
      title="Sorting Center"
      fullWidth
      secondaryActions={[
        {
          content: "Manual Transfer",
          icon: SendIcon,
          disabled: selectedRows.length === 0,
          onAction: () => {
            setActiveTransfer(true);
          },
        },
      ]}
    >
      <Card padding="0">
        {loadingMarkup}

        <Filters
          queryValue={queryValue}
          queryPlaceholder="Search..."
          filters={filters}
          appliedFilters={appliedFilters}
          onQueryChange={handleFiltersQueryChange}
          onQueryClear={handleQueryValueRemove}
          onClearAll={handleFiltersClearAll}
        />

        <DataTable
          columnContentTypes={["text", "text", "text", "text"]}
          headings={[
            <Checkbox
              label="Select all"
              labelHidden
              checked={
                rowIds.length > 0 && selectedRows.length === rowIds.length
              }
              onChange={(checked) => {
                setSelectedRows(checked ? [...rowIds] : []);
              }}
            />,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              EAN
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Supplier Name
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Client
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Phone Number
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Address
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Amount
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Status
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Time
            </Text>,
            // <Text variant="bodyMd" as="p" fontWeight="medium">
            //   Assigned Driver
            // </Text>,
            // <Text variant="bodyMd" as="p" fontWeight="medium">
            //   Longitude
            // </Text>,
            // <Text variant="bodyMd" as="p" fontWeight="medium">
            //   Latitude
            // </Text>,
            // <Text variant="bodyMd" as="p" fontWeight="medium">
            //   Notes
            // </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
          ]}
          rows={pageObject.tableItems.map((row, index) => {
            const itemId = rowIds[index];
            return [
              <Checkbox
                checked={selectedRows.includes(itemId)}
                onChange={(checked) => handleSelectRow(itemId, checked)}
              />,
              ...row, // existing row data
            ];
          })}
          verticalAlign="middle"
          increasedTableDensity
          footerContent={
            pageObject.tableItems?.length &&
            `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
          }
          hasZebraStripingOnData
        />
        {emtyState}
        {Math.ceil(pageObject.tableTotalPages / perPage) >= 2 && (
          <div
            style={{
              paddingTop: "10px",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <Pagination
              variant="outlined"
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
            />
            {/* <Pagination
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
              size="large"
            /> */}
          </div>
        )}

        {toastMarkup}

        <Modal
          open={activeTransfer}
          onClose={handleChangeModalTransfer}
          title={`Transfer Orders (Orders count:${selectedRows.length})`}
          primaryAction={{
            content: "Yes",
            onAction: handleYesTransfer,
            loading: isSaving,
          }}
          secondaryActions={[
            {
              content: "No",
              loading: isSaving,
              onAction: handleChangeModalTransfer,
            },
          ]}
        >
          <Modal.Section>
            <FormLayout>
              <Text>Are you sure you want to transfer these orders?</Text>
            </FormLayout>
          </Modal.Section>
        </Modal>

        <Modal
          open={activeCancel}
          onClose={handleChangeModalCancel}
          title="Cancel Order"
          primaryAction={{
            content: "Yes",
            onAction: handleYesCancel,
            loading: isSaving,
          }}
          secondaryActions={[
            {
              content: "No",
              loading: isSaving,
              onAction: handleChangeModalCancel,
            },
          ]}
        >
          <Modal.Section>
            <FormLayout>
              <Text>Are you sure you want to cancel this order?</Text>
              <TextField
                value={noteValue}
                onChange={handleChangeNote}
                label="Note"
                multiline={4}
                requiredIndicator
                error={noteError}
              />
            </FormLayout>
          </Modal.Section>
        </Modal>
      </Card>
    </Page>
  );
  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      default:
        return value;
    }
  }
  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
  function getFirstNonNullValue(obj) {
    for (const value of Object.values(obj)) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
};

export default SortingCenter;
